var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEmail = function SvgEmail(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 13.5,
    viewBox: "0 0 14 10",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M0 1.62v6.46c0 .89.72 1.61 1.62 1.61h10.77c.89 0 1.61-.72 1.61-1.61V1.62C14 .72 13.28 0 12.4 0H1.62C.72 0 0 .72 0 1.62m1.08.28v6.18c0 .3.24.54.54.54h10.77c.3 0 .53-.25.53-.54V1.9L9.98 3.94l1.7 1.56a.54.54 0 0 1-.74.8L9.07 4.56l-.98.68c-.66.45-1.52.45-2.18 0l-.98-.68L3.06 6.3a.54.54 0 0 1-.73-.8l1.7-1.56L1.07 1.9Zm11.15-.82H1.77l4.75 3.27c.29.2.67.2.96 0z",
    clipRule: "evenodd"
  })));
};
export default SvgEmail;